module.exports = __webpack_public_path__ + "img/binance_sign.2d15ec68.svg";